
export const RESET_LOADING = 'RESET_LOADING'
export const CHECK_EMAIL_ERROR = 'CHECK_EMAIL_ERROR'
export const CHECK_VALIDE = 'CHECK_VALIDE'
export const CONFIRM_RESET_FAILED = 'CONFIRM_RESET_FAILED'
export const CONFIRM_RESET_SUCCESS = 'CONFIRM_RESET_SUCCESS'
export const CONFIRM_RESET_LOADING = 'CONFIRM_RESET_LOOADING'